import { Locales } from '@ratehub/base-ui';

import LENDER_TYPES from '../definitions/LenderTypes';


/**
 * 
 * @param {string} providerSlug
 * @param {string} lenderType
 * @param {string=} locale
 * @returns {string} The formatted path of the provider page on Ratehub.ca 
 */
export default function getProviderRatesURL({ providerSlug, lenderType }, locale=Locales.ENGLISH) {
    const isLocaleEn = locale === Locales.ENGLISH;
    let path;

    switch (lenderType) {
        case LENDER_TYPES.BROKER:
            path = isLocaleEn ? 'brokers' : 'courtiers';
            break;
        case LENDER_TYPES.TRUST_COMPANY:
            path = isLocaleEn ? 'trust-companys' : 'societe-de-fiducies';
            break;
        case LENDER_TYPES.CREDIT_UNION:
            path = isLocaleEn ? 'credit-unions' : 'caisses';
            break;
        default:
            path = isLocaleEn ? 'banks' : 'banques';
    }

    return isLocaleEn
        ? `/${path}/${providerSlug}-mortgage-rates`
        : `/${path}/${providerSlug}-hypotheque`;
}